import LandingPage from './landing/LandingPage';
import VouchersPage from './vouchers/VouchersPage';
import BookNow from './booking/BookNow';
import BookingPage from './booking/Booking';
import AboutPage from './about/AboutPage';
import CoursesPage from './courses/CoursesPage';
import ReviewsPage from './reviews/ReviewsPage';
import ContactPage from './../views/contact/ContactPage';

import ErrorPage from './ErrorPage';

import { BrowserRouter, Route, Switch } from 'react-router-dom';
import {
	ChemicalPeelsPage,
	CleftLipRepairPage,
	DermalLipFillerPage,
	DesofacePage,
	DissolvingFillerPage,
	EndoliftPage,
	NonSurgicalRhinoplastyPage,
	PdoThreadsPage,
	PolynucleotidesPage,
	PrgfPage,
	SclerotherapyPage,
	SculptraPage,
	SkinBoostersPage,
	SkinConsultationPage,
	TeethWhiteningPage,
	TreatmentsPage,
	WeightLossInjectionsPage,
} from './treatments';
import AntiWrinklePage from './treatments/AntiWrinklePage';

export default function Routes() {
	return (
		<BrowserRouter forceRefresh={true}>
			<Switch>
				<Route path="/" exact component={LandingPage} />
				<Route path="/voucher" exact component={VouchersPage} />
				<Route path="/book-now" exact component={BookNow} />
				<Route path="/booking/:slug" exact component={BookingPage} />
				<Route path="/about" exact component={AboutPage} />
				<Route path="/courses" exact component={CoursesPage} />
				<Route path="/reviews" exact component={ReviewsPage} />
				<Route path="/contact-us" exact component={ContactPage} />
				<Route path="/treatments/anti-wrinkle-injection" exact component={AntiWrinklePage} />
				<Route path="/treatments/cleft-lip-repair" exact component={CleftLipRepairPage} />
				<Route path="/treatments/dermal-and-lip-filler" exact component={DermalLipFillerPage} />
				<Route path="/treatments/fat-dissolving-injection" exact component={DesofacePage} />
				<Route path="/treatments/dissolving-filler" exact component={DissolvingFillerPage} />
				<Route path="/treatments/pdo-threads" exact component={PdoThreadsPage} />
				<Route path="/treatments/plasma-rich-in-growth-factors" exact component={PrgfPage} />
				<Route path="/treatments/skinboosters" exact component={SkinBoostersPage} />
				<Route path="/treatments/chemical-peels" exact component={ChemicalPeelsPage} />
				<Route path="/treatments/polynucleotides" exact component={PolynucleotidesPage} />
				<Route path="/treatments/sculptra" exact component={SculptraPage} />
				<Route path="/treatments/non-surgical-rhinoplasty" exact component={NonSurgicalRhinoplastyPage} />
				<Route path="/treatments/endolift" exact component={EndoliftPage} />
				<Route path="/treatments/sclerotherapy" exact component={SclerotherapyPage} />
				<Route path="/treatments/skin-consultation" exact component={SkinConsultationPage} />
				<Route path="/treatments/teeth-whitening" exact component={TeethWhiteningPage} />
				<Route path="/treatments/weight-loss-injections" exact component={WeightLossInjectionsPage} />
				<Route path="/treatments" exact component={TreatmentsPage} />
				<Route path="*" exact component={ErrorPage} />
			</Switch>
		</BrowserRouter>
	);
}
